import React, { useState } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { Content, CustomForm, CustomInput } from '../../../fgs';
import { alterPasswordValidationMessages, alterPasswordValidations } from '../../validations/validations';
import { Col, Row } from 'reactstrap';

import { updateUser } from '../../../services/api';

export const AlterPasswordPage = () => {
  const { id } = useParams();
  const history = useHistory();
  const [form, setForm] = useState({
    password: '',
    passwordConfirmation: ''
  });

  const redirectToProfile = () => {
    history.push(`/dashboard/users/${id}/profile`);
  };

  const onSave = () => {
    updateUser(id, form).then(() => {
      redirectToProfile();
    });
  };

  const onInputChange = (e) => {
    const newForm = Object.assign({}, form);
    newForm[e.target.name] = e.target.value;

    setForm(newForm);
  };

  const formControls = [
    { title: 'Salvar', props: { color: 'primary', type: 'submit' } },
    { 
      title: 'Cancelar', 
      props: { 
        color: 'secondary', 
        onClick: redirectToProfile
      }
    }
  ];

  return (
    <Content>
      <CustomForm
        validationMessages={alterPasswordValidationMessages}
        validations={alterPasswordValidations}
        form={form}
        formControls={formControls}
        onSubmit={onSave}>
        <Row>
          <Col xs="6">
            <CustomInput
              labelText="Senha"
              hasIcon={true}
              iconName="User"
              iconPosition="prepend"
              inputName="password"
              inputType="password"
              placeholder="****"
              onChange={onInputChange}
              inputValue={form.password}
              actionIcon="Eye" />
          </Col>

          <Col xs="6">
            <CustomInput
              labelText="Confirmação de Senha"
              hasIcon={true}
              iconName="User"
              iconPosition="prepend"
              inputName="passwordConfirmation"
              inputType="password"
              placeholder="****"
              onChange={onInputChange}
              inputValue={form.passwordConfirmation}
              actionIcon="Eye" />
          </Col>
        </Row>
      </CustomForm>
    </Content>
  );
};